export function setUser (state, payload) {
  state.user = payload
}

export function setTwoFactor (state, payload) {
  if (state.user) {
    state.user.has_two_factor = !!payload
  }
}
